import styled from 'styled-components'
import { Colors, Typography } from 'cio-design-library/design-tokens'
import { Icon24 } from 'builder/components/Icon'
import { ButtonV2 } from 'builder/components/Button'
import Preview from 'builder/components/Preview'
import { ScrollContainerWithHiddenScrollbar } from '../../ScrollContainer'

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const ScrollContainer = styled(ScrollContainerWithHiddenScrollbar)`
  width: 100%;
  height: 100%;
  padding: 4px;
`

export const InnerContainer = styled.div`
  max-width: 980px;
  margin: auto;
`

export const PagesContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  bottom: 24px;
  padding: 8px;
  border-radius: 40px;
  width: fit-content;
  background-color: ${Colors.Neutral100};
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  gap: 2px;
`

export const IconsButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  width: 24px;
  height: 24px;
  cursor: pointer;
  opacity: 1;
  color: ${Colors.White};

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
    color: ${Colors.Neutral50};
  }

  &:hover {
    border-radius: 50%;
    background-color: ${Colors.Neutral80};
  }
`

export const RightIcon = styled(Icon24.ChevronRight)``
export const LeftIcon = styled(Icon24.ChevronLeftCurrentColor)``

export const Page = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 2px;
  color: ${Colors.White};
  ${Typography.sizes.Caption}
`

export const CustomizeContainer = styled.div`
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  width: fit-content;
  color: ${Colors.White};
  opacity: 0;
  transition: opacity 0.1s ease-out;

  ${Container}:hover & {
    opacity: 1;
  }
`

export const CustomizeIcon = styled(Icon24.Colors)`
  opacity: 1;
  transform: none;
  transition: none;
`

export const CustomizeButton = styled(ButtonV2)`
  border-radius: 32px;
  padding: 16px 8px 16px 16px;
  padding-right: 8px;
  transition: padding 0.2s ease-in-out;

  &:hover {
    padding-right: 16px;
  }
`

export const AnimatedText = styled.span`
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  max-width: 0px;
  transition: transform 0.2s ease-in-out, max-width 0.2s ease-in-out;

  ${CustomizeButton}:hover & {
    max-width: 200px;
  }
`

export const StyledPreview = styled(Preview)`
  border-radius: 0;
  box-shadow: none;
`
